import { defineComponent as _defineComponent } from 'vue'
import LocalSwitcher from "./LocalSwitcher";
import {KeycloakService, defaultRoles, warrantyReadRoles, warrantyEditRoles} from "@/services/KeycloakService";
import {onMounted, ref} from "vue";
import {ConfigFileService} from "@/services/ConfigFileService";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderView',
  setup(__props) {

const userInitials = ref<string>('')
const menu = ref<{}[]>([
    {
        key: 'search',
        ref: "/search",
        roles: defaultRoles
    },
    {
        key: 'warranty_search',
        ref: '/warranty',
        roles: [...warrantyReadRoles,...warrantyEditRoles]
    },
    {
        key: 'warranty_user_create',
        ref: '/warranty-user/create',
        roles: warrantyEditRoles
    }
])

onMounted(() => {
    const firstName = KeycloakService.firstName;
    const lastName = KeycloakService.lastName;
    userInitials.value = firstName.charAt(0) + lastName.charAt(0);
})

const checkRole = (roles: string[]):boolean => {
    if (roles.length == 0 || roles.some(r => KeycloakService.roles.includes(r))) {
        return true
    }
    return false
}

const logout = () => {
    const id_token_hint = KeycloakService.idToken
    const redirect_uri = window.location.href
    const logoutUrl = ConfigFileService.keycloakUrl + "realms/" + ConfigFileService.keycloakRealm + "/protocol/openid-connect/logout"
        + "?post_logout_redirect_uri=" + encodeURIComponent(redirect_uri)
        + "&id_token_hint=" + id_token_hint
    window.location.href = logoutUrl
}

return { __sfc: true,userInitials, menu, checkRole, logout, LocalSwitcher, ref }
}

})